'use client';

import { SwitchProps } from './types';

import { classNames } from '@/shared/lib/classNames/classNames';

export const Switch = ({
  checked,
  onChange,
  disabled,
  className,
  id,
}: SwitchProps) => {
  const handleClick = () => {
    if (!disabled) {
      onChange(!checked);
    }
  };

  return (
    <button
      id={id}
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label="switch"
      disabled={disabled}
      onClick={handleClick}
      className={classNames({
        cls: 'relative inline-flex h-[24px] max-h-[24px] min-h-[24px] w-[40px] min-w-[40px] items-center rounded-full transition-colors duration-200 ease-in-out',
        mods: {
          'bg-custom-base-inverse-primary': checked && !disabled,
          'bg-custom-surface-contrast-low': !checked || disabled,
          'cursor-not-allowed opacity-50': disabled,
          'cursor-pointer': !disabled,
        },
        additional: [className],
      })}
    >
      <span
        className={classNames({
          cls: 'inline-block h-[16px] w-[16px] transform rounded-full bg-white transition duration-200 ease-in-out',
          mods: {
            'translate-x-[21px]': checked,
            'translate-x-[4px]': !checked,
          },
        })}
      />
    </button>
  );
};
